<section class="component-container mat-typography mat-body mat-app-background">
  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-inputs">
        <section>
          <!-- agencyNumber -->
          <mat-form-field appearance="outline">
            <mat-label>Agency Number</mat-label>
            <input matInput formControlName="agencyNumber" />
            @if (formControls.agencyNumber.errors) {
              <mat-error>
                @if (formControls.agencyNumber.errors.required) {
                  <span>Required</span>
                }
                @if (formControls.agencyNumber.errors.pattern) {
                  <span>Pattern not matched:
                  {{formControls.agencyNumber.errors | json}}</span>
                }
              </mat-error>
            }
          </mat-form-field>
          <!-- producerNumber -->
          <mat-form-field appearance="outline">
            <mat-label>Producer Number</mat-label>
            <input matInput formControlName="producerNumber" />
            @if (formControls.producerNumber.errors) {
              <mat-error>
                @if (formControls.producerNumber.errors.required) {
                  <span>Required</span>
                }
                @if (formControls.producerNumber.errors.pattern) {
                  <span>Invalid Format</span>
                }
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>From Email</mat-label>
            <input matInput formControlName="fromEmailAddress" />
            @if (formControls.fromEmailAddress.errors) {
              <mat-error>
                @if (formControls.fromEmailAddress.errors.required) {
                  <span>
                    Required
                  </span>
                }
                @if (formControls.fromEmailAddress.errors.maxlength) {
                  <span>
                    Character limit: {{formControls.fromEmailAddress.errors?.maxlength.requiredLength}} (Current: {{formControls.fromEmailAddress.errors?.maxlength.actualLength}})
                  </span>
                } @else {
                  @if (formControls.fromEmailAddress.errors.email) {
                    <span>
                      Email format required: XXXX&#64;XXXX.XXXX
                    </span>
                  }
                }
              </mat-error>
            }
          </mat-form-field>
          <!-- agentPhoneNumber -->
          <mat-form-field appearance="outline">
            <mat-label>Agent Phone Number</mat-label>
            <input matInput formControlName="agentPhoneNumber" [ptlMask]="entryMask" />
            @if (formControls.agentPhoneNumber.errors) {
              <mat-error>
                @if (formControls.agentPhoneNumber.errors.required) {
                  <span>Required</span>
                }
                @if (formControls.agentPhoneNumber.errors.maxlength) {
                  <span>Max-length exceeded
                  ({{formControls.agentPhoneNumber.errors.maxlength.requiredLength}})</span>
                }
                @if (formControls.agentPhoneNumber.errors.pattern) {
                  <span>Pattern Required: (000) 000-0000</span>
                }
              </mat-error>
            }
          </mat-form-field>
        </section>
        <section>
          <!-- clientName -->
          <mat-form-field appearance="outline">
            <mat-label>Client Name</mat-label>
            <input matInput formControlName="clientName" />
            @if (formControls.clientName.errors) {
              <mat-error>
                @if (formControls.clientName.errors.required) {
                  <span>Required</span>
                }
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>To E-mail</mat-label>
            <input matInput formControlName="toEmailAddress" />
            @if (formControls.toEmailAddress.errors) {
              <mat-error>
                <!-- Required error -->
                @if (formControls.toEmailAddress.errors.required) {
                  <span>
                    Required
                  </span>
                }
                <!-- Max length error -->
                @if (formControls.toEmailAddress.errors.maxlength) {
                  <span>
                    Character limit: {{formControls.toEmailAddress.errors?.maxlength.requiredLength}} (Current: {{formControls.toEmailAddress.errors?.maxlength.actualLength}})
                  </span>
                } @else {
                  <!-- Email format error -->
                  @if (formControls.toEmailAddress.errors.email) {
                    <span>
                      Email format required: XXXX&#64;XXXX.XXXX
                    </span>
                  }
                }
              </mat-error>
            }
          </mat-form-field>
          <!-- toEmailAddressRepeat -->
          <mat-form-field appearance="outline">
            <mat-label>To E-mail (confirm)</mat-label>
            <input matInput formControlName="toEmailAddressRepeat" />
            @if (formControls.toEmailAddressRepeat.errors) {
              <mat-error>
                @if (formControls.toEmailAddressRepeat.errors.required) {
                  <span>
                    Required
                  </span>
                }
                @if (formControls.toEmailAddressRepeat.errors.maxlength) {
                  <span>
                    Character limit: {{formControls.toEmailAddressRepeat.errors?.maxlength.requiredLength}} (Current: {{formControls.toEmailAddressRepeat.errors?.maxlength.actualLength}})
                  </span>
                } @else {
                  @if (formControls.toEmailAddressRepeat.errors.email) {
                    <span>
                      Email format required: XXXX&#64;XXXX.XXXX
                    </span>
                  }
                }
                @if (formControls.toEmailAddressRepeat.errors.emailNoMatch) {
                  <span>
                    Recipient e-mails do not match
                  </span>
                }
              </mat-error>
            }
          </mat-form-field>
          <!-- region for NY only -->
          @if (isNewYorkRegion()) {
            <mat-form-field appearance="outline">
              <mat-label>Region</mat-label>
              <mat-select formControlName="region">
                @for (option of nyRegionValues; track option) {
                  <mat-option [value]="option.region">{{option.region}} -
                  {{removeOf(option.description)}}</mat-option>
                }
              </mat-select>
              @if (formControls.region.errors) {
                <mat-error>
                  @if (formControls.region.errors.required) {
                    <span>Required</span>
                  }
                </mat-error>
              }
            </mat-form-field>
          }
          <!-- region for PA only -->
          @if (isPARegion()) {
            <mat-form-field appearance="outline">
              <mat-label>Region</mat-label>
              <mat-select formControlName="region">
                @for (option of paRegionValues; track option) {
                  <mat-option [value]="option.region">{{option.region}} -
                  {{option.description}}</mat-option>
                }
              </mat-select>
              @if (formControls.region.errors) {
                <mat-error>
                  @if (formControls.region.errors.required) {
                    <span>Required</span>
                  }
                </mat-error>
              }
            </mat-form-field>
          }
        </section>
      </div>
      <div class="button-container">
        @if (!showSpinner) {
          <button type="submit" mat-raised-button color="primary">Send Email</button>
        } @else {
          <mat-spinner [diameter]="36"></mat-spinner>
        }
      </div>
    </form>
  }
  @if (displayEmailSentMessage) {
    <div style="text-align: center">
      Email sent. Review form and add new email to send another e-mail.
    </div>
  }

</section>